export const AUDIT_SECTION = 'Audit';

// The backend returns a raw array of report definitions (not a { items }
// envelope like Azuro) and `status` comes through as a number (1 = Active)
// rather than the string "Active".
const isActive = (report) => {
  if (report.status === undefined || report.status === null) return true;
  if (typeof report.status === 'number') return report.status === 1;
  if (typeof report.status === 'string')
    return report.status.toLowerCase() === 'active';
  return true;
};

export const splitBySection = (data) => {
  const rawItems = Array.isArray(data)
    ? data
    : Array.isArray(data?.items)
      ? data.items
      : [];
  const active = rawItems.filter(isActive);
  return {
    reports: active.filter((r) => r.section !== AUDIT_SECTION),
    audit: active.filter((r) => r.section === AUDIT_SECTION),
  };
};
